import React, { useEffect } from 'react';
import { Box, Container, Divider, Typography } from '@mui/material';
import { SecureTokenBalance } from './components/SecureTokenBalance';
import { TokenGraph } from './components/TokenGraph';
import { useNetwork } from '../../../utils/network';
import { useUser } from '../../../contexts/UserContext';

export const TokenStats = () => {
  const { get } = useNetwork();
  const { user, setUser } = useUser();

  useEffect(() => {
    const getUserBalances = async () => {
      try {
        const result = await get('/secure-tokens/balances', true);
        const balances = result?.balances;

        if (!balances) return;

        setUser({
          ...user,
          tokenAmount: balances.tokenAmount ?? user.tokenAmount,
          earnedTokens: balances.earnedTokens ?? user.earnedTokens
        });
      } catch (error: any) {
        console.log('Failed to fetch user balances:', error);
      }
    };

    getUserBalances();
  }, []);

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              font: '800 10px ui-monospace, Menlo, Consolas, monospace',
              letterSpacing: '0.4em',
              textTransform: 'uppercase',
              color: '#ffcf40'
            }}
          >
            INC Token
          </Typography>
          <Typography
            sx={{
              mt: 1.25,
              fontWeight: 900,
              fontSize: 'clamp(24px, 3.4vw, 36px)',
              lineHeight: 1,
              letterSpacing: '-0.02em',
              color: '#e8f4fb'
            }}
          >
            Your{' '}
            <Box component="span" sx={{ color: '#38e8ff' }}>
              token
            </Box>
          </Typography>
          <Typography
            sx={{
              mt: 1.25,
              font: '600 13px/1.55 ui-monospace, Menlo, Consolas, monospace',
              color: '#8ea3b3',
              maxWidth: 640
            }}
          >
            Your INC balance, live price, and history in one place.
          </Typography>
        </Box>

        {/* Token Balance Section */}
        <Box sx={{ mb: 4 }}>
          <SecureTokenBalance />
        </Box>
        
        {/* Divider */}
        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        {/* Token Graph Section */}
        <Box sx={{ width: '100%' }}>
          <TokenGraph />
        </Box>
      </Box>
    </Container>
  );
};
